exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-fullpage-box {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n.vux-fullpage-box:after {\n  display: block;\n  content: ' ';\n  height: 0;\n  clear: both;\n}\n.vux-fullpage-box.vux-fullpage-box-anim {\n  -webkit-transition: all 500ms ease-out 0s;\n  transition: all 500ms ease-out 0s;\n}\n.vux-fullpage-item {\n  display: block;\n  overflow: hidden;\n}\n.vux-fullpage-dir-h {\n  float: left;\n}\n", ""]);

// exports
